import request from 'utils/request';

import { transformDateRangeToFilters } from './transformations';

const accounts = {
  create: async (data) => await request.post('/accounts/', data),
  delete: async (accountId) => await request.delete(`/accounts/${accountId}`),
  get: async (accountId) => await request.get(`/accounts/${accountId}`),
  update: async (accountId, data) =>
    await request.patch(`/accounts/${accountId}`, data),
  bulkUpdate: async (data) =>
    await request.patch('/accounts/bulk_update', data),
  bulkDelete: async (data) =>
    await request.delete('/accounts/bulk_delete', data),
  list: async () =>
    await request.get(
      '/accounts/',
      {},
      {
        headers: {
          Accept: 'text/csv',
        },
      },
    ),

  billingAddresses: {
    create: async (accountId, data) =>
      await request.post(`/accounts/${accountId}/billing_addresses/`, data),
    delete: async (billingAddressId) =>
      await request.delete(`/accounts/billing_addresses/${billingAddressId}`),
    get: async (billingAddressId) =>
      await request.get(`/accounts/billing_addresses/${billingAddressId}`),
    update: async (billingAddressId, data) =>
      await request.patch(
        `/accounts/billing_addresses/${billingAddressId}`,
        data,
      ),
  },

  facilities: {
    list: async () =>
      await request.get(
        '/accounts/facilities/',
        {},
        {
          headers: {
            Accept: 'text/csv',
          },
        },
      ),
    create: async (accountId, data) =>
      await request.post(`/accounts/${accountId}/facilities/`, data),
    delete: async (facilityId) =>
      await request.delete(`/accounts/facilities/${facilityId}`),
    get: async (facilityId) =>
      await request.get(`/accounts/facilities/${facilityId}`),
    update: async (facilityId, data) =>
      await request.patch(`/accounts/facilities/${facilityId}`, data),
  },
};

const contacts = {
  create: async (data) => await request.post('/contacts/', data),
  delete: async (contactId) => await request.delete(`/contacts/${contactId}`),
  get: async (contactId) => await request.get(`/contacts/${contactId}`),
  update: async (contactId, data) =>
    await request.patch(`/contacts/${contactId}`, data),
  bulkUpdate: async (data) =>
    await request.patch('/contacts/bulk_update', data),
  bulkDelete: async (data) =>
    await request.delete('/contacts/bulk_delete', data),
  list: async () =>
    await request.get(
      '/contacts/',
      {},
      {
        headers: {
          Accept: 'text/csv',
        },
      },
    ),
};

const paymentTerms = {
  create: async (paymentTerms) =>
    await request.post(`/customers/payment_terms/`, paymentTerms),
  get: async () => await request.get(`/customers/payment_terms/`),
};

export default {
  accounts,
  contacts,
  paymentTerms,

  listMetrics: async (groupId, params) => {
    const metricsContacts = await request.get(
      `/customers/groups/${groupId}/metrics`,
      {
        ...params,
        ...(transformDateRangeToFilters(params.sentDate, 'active') ||
          undefined),
        process_in: params.processIn ? params.processIn.join(',') : undefined,
      },
    );
    const ret = {
      contactFilters: { ...params },
      metricsContacts,
    };
    return ret;
  },
};
